import { retrieveProductionToggles, isEnabled } from '@nuskin/ns-feature-flags';

const accertifyFraudService = function () {

    let transactionId;
    let accertifyReceivedTransactionID = false;
    let logsForDebugging = false;
    retrieveProductionToggles().then(() => {
        logsForDebugging = isEnabled('cx8_380_debugging');
    })

    const publicMethods = {
        initAccertify: (marketConfig) => {
            const ustr = Math.random().toString();
            const udat = new Date();
            const utid = ustr.substr(2, 5) + udat.getTime() + ustr.substr(7, 3);



            transactionId = `${marketConfig.accertify.transactionIdPrefix}-${utid}`;
            accertifyReceivedTransactionID = false;
            let beaconScript = document.getElementById('bcn')

            if (beaconScript === null) {
                beaconScript = document.createElement('script');
                beaconScript.setAttribute('type', 'text/javascript');
                beaconScript.setAttribute('src', marketConfig.accertify.dataCollectorUrl);
                beaconScript.setAttribute('dvct', '500');
                beaconScript.setAttribute('sid', marketConfig.accertify.sessionId);
                beaconScript.setAttribute('dvci', publicMethods.getTransactionID());
                beaconScript.setAttribute('id', 'bcn');
                beaconScript.setAttribute('dvc', 'a');
                beaconScript.setAttribute('async', 'true');
                beaconScript.onload = function () { publicMethods.registerCallbackWithAccertify(); };
                document.head.appendChild(beaconScript);
            } else {
                beaconScript.setAttribute('dvci', publicMethods.getTransactionID());
                publicMethods.startDataCollection();
            }

        },

        registerCallbackWithAccertify: () => {
            if (logsForDebugging) {
                console.log("CX8:\n\tRegister the callback function")
            }
            if (window.hasOwnProperty('_bcn') && window._bcn.hasOwnProperty('dvc')) {
                window._bcn.dvc.setSubmissionCallback(publicMethods.setAccertifyReceivedTransactionIDToTrue);
            }
        },

        setAccertifyReceivedTransactionIDToTrue: () => {
            accertifyReceivedTransactionID = true;

            if (logsForDebugging) {
                console.log("CX8:\n\tcallback function has been invoked")
            }
        },

        getAccertifyReceivedTransactionID: () => {
            return accertifyReceivedTransactionID;
        },

        retrieveAccertifyTransactionIdCustomPaymentField: () => {
            if (logsForDebugging) {
                console.log("CX8:\n\t adding custom payment field.");
            }

            return {
                Key: "ACCERTIFY_TRANSACTION_ID",
                Value: publicMethods.getTransactionID(),
                Type: "ACCERTIFY"
            };
        },

        accertifyInMarketConfig: (marketConfig) => {
            if (marketConfig.accertify === undefined) {
                return false;
            }
            if (!marketConfig.accertify.enabled) {
                return false;
            }
            if (
                marketConfig.accertify.sessionId === undefined ||
                marketConfig.accertify.transactionIdPrefix === undefined ||
                marketConfig.accertify.dataCollectorUrl === undefined) {
                return false;
            }
            return true;
        },

        getTransactionID: () => {
            return transactionId;
        }

    };

    return publicMethods;
}();

export default accertifyFraudService;